import { useState } from "react";
import Modal from "../../components/common/Modal";
import CrudForm from "../../components/common/crud/CrudForm";
import stockCategoryService from "../../services/stockCategoryService";
import alertService from "../../utils/alertService";
import { normalizeApiError } from "../../utils/apiError";

const stockCategoryFormSchema = [
  {
    name: "stockCategoryName",
    label: "Category Name",
    type: "text",
    placeholder: "e.g. AC JALI",
    validation: { required: true, minLength: 2, maxLength: 100 },
  },
  {
    name: "stockCategoryShortName",
    label: "Short Name",
    type: "text",
    placeholder: "e.g. AC JALI",
    validation: { required: true, minLength: 1, maxLength: 50 },
  },
  {
    name: "isActive",
    label: "Active",
    type: "checkbox",
    initialValue: true,
  },
];

function StockCategoryCreateModal({ isOpen, onClose, onSuccess }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setIsSubmitting(true);
    try {
      await stockCategoryService.createStockCategory(values);
      alertService.success("Stock Category created successfully.");
      onSuccess?.();
      onClose();
    } catch (err) {
      alertService.error(normalizeApiError(err).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Add New Stock Category">
      <CrudForm
        mode="create"
        schema={stockCategoryFormSchema}
        initialValues={{ isActive: true }}
        isSubmitting={isSubmitting}
        onSubmit={handleSubmit}
        onCancel={onClose}
      />
    </Modal>
  );
}

export default StockCategoryCreateModal;
